import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import { DELETE_ADMIN_APPLICATION_FILE_URL } from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const useDeleteAdminApplicationFile = ({ onSuccess, onError }: Input = {}) => {
  const deleteAdminApplicationFile = async (fileUuid: string) => {
    await axiosClient.delete<void>(DELETE_ADMIN_APPLICATION_FILE_URL(fileUuid));
  };

  return useCustomMutation(deleteAdminApplicationFile, {
    onSuccess,
    onError,
  });
};
